
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "0c272e09f7fca861ca0cef8ca5ef43cd42e40838",
  "nuxt": {
    "buildId": "272b3044-b023-4693-8cad-580ff0fcdab4"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
